module.exports = __webpack_public_path__ + "resources/img/solution_finance_rescue2_v2.13b1ba68c4fca2dd61c58e949acb0795.png";